module.exports = __webpack_public_path__ + "manufacture.1f0d9b796e68aa9dbc1b.png";